import { createGlobalState, useLocalStorage } from '@vueuse/core'
import storageKeys from '../../../../common/storage-keys'
import { ref } from 'vue'

export const useWebcamRecorder = createGlobalState(() => {
  const cameraDeviceId = useLocalStorage(storageKeys.WEBCAM_RECORDER.CAMERA_DEVICE_ID, null)
  const microphoneDeviceId = useLocalStorage(storageKeys.WEBCAM_RECORDER.MICROPHONE_DEVICE_ID, null)
  const videoQuality = useLocalStorage(storageKeys.WEBCAM_RECORDER.VIDEO_QUALITY, '720p')
  const isMirrorVideo = useLocalStorage(storageKeys.WEBCAM_RECORDER.IS_MIRROR_VIDEO, false)
  const isDisplayTeleprompter = useLocalStorage(storageKeys.WEBCAM_RECORDER.IS_DISPLAY_TELEPROMPTER, true)
  const isVirtualBackgroundBlur = useLocalStorage(storageKeys.WEBCAM_RECORDER.IS_BLUR_BACKGROUND, false)
  const blurAmount = useLocalStorage(storageKeys.WEBCAM_RECORDER.BLUR_AMOUNT, 15)
  const isVirtualBackgroundImage = useLocalStorage(storageKeys.WEBCAM_RECORDER.IS_VIRTUAL_BACKGROUND, false)
  const virtualBackgroundImage = useLocalStorage(storageKeys.WEBCAM_RECORDER.VIRTUAL_BACKGROUND_IMAGE, null)
  const edgeBlurAmount = useLocalStorage(storageKeys.WEBCAM_RECORDER.EDGE_BLUR_AMOUNT, 8)

  const webcamScale = ref(1)
  const webcamTranslate = ref({ x: 0, y: 0 })
  const canvasRef = ref()

  return {
    cameraDeviceId,
    microphoneDeviceId,
    videoQuality,
    isMirrorVideo,
    isDisplayTeleprompter,
    isVirtualBackgroundBlur,
    blurAmount,
    isVirtualBackgroundImage,
    virtualBackgroundImage,
    edgeBlurAmount,

    webcamScale,
    webcamTranslate,

    canvasRef
  }
})
